import { Directive, HostListener, Input } from '@angular/core'
import { environment } from 'src/environments/environment'

declare const firebaseLogEvent: Function
declare const window: any

@Directive({
	selector: '[myAldEvent]',
	standalone: true
})
export class MyAldEventDirective {
	@Input()
	myAldEvent: string

	@Input()
	myAldEventLabel: string

	constructor() {}

	@HostListener('mouseup')
	onMouseUp() {
		if (environment.mobile) {
			firebaseLogEvent(this.myAldEvent, this.myAldEventLabel)
		} else {
			//TODO da verificare approccio per MATOMO

			//vecchia logica per  google analytics
			if (environment.env === 'uat' || environment.env === 'prod') {
				window.dataLayer = window.dataLayer || []
				window.dataLayer.push({
					event: 'gaEvent',
					eventCategory: 'myald',
					eventAction: this.myAldEvent,
					eventLabel: this.myAldEventLabel,
				})
			}
		}
	}
}
